module.exports = __webpack_public_path__ + "assets/b98.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b98.png
// module id = 691
// module chunks = 0